import { render, staticRenderFns } from "./IconPieChart.vue?vue&type=template&id=7fac781c&"
import script from "./IconPieChart.vue?vue&type=script&lang=js&"
export * from "./IconPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports